<template>
  <!-- 客户联系人展示（中部） -->
  <div class="clientContact">
    <div class="client-header">
      <div class="title">联系人</div>
      <el-button @click="$emit('showMoreContact')">更多</el-button>
    </div>
    <!-- 客户的联系人展示 -->
    <div class="concatPersons" v-if="ClientContacts.length !== 0">
      <!-- 单个客户的联系人信息 -->
      <div class="concatPerson" v-for="item in ClientContacts" :key="item.contact_id" @click="ContactClick(item)">
        <el-avatar :size="50" icon="el-icon-user-solid"></el-avatar>
        <div class="concatPersonName">{{ item.name }}</div>
        <div class="concatPersonDept" :title="item.dept + ' - ' + item.level">{{ item.dept + ' - ' + item.level }}</div>
      </div>
    </div>
    <el-empty v-else description="暂无数据"></el-empty>
  </div>
</template>

<script>
import {getClientContact} from "@/api/api";
export default {
  name: "ClientContact",
  data(){
    return {
      ClientContacts:null
    }
  },
  props:{
    clientId:{
      required:true
    },
    refreshId: {
      required:true
    }
  },

  watch: {
    refreshId(newVal) {
      this.getData()
    }
  },

  methods: {
    async getData(){
      const {respData} = await getClientContact({"client_id": this.clientId})
      this.ClientContacts = respData
    },

    ContactClick(contactItem){
      this.$emit('contactClick', contactItem)
    }

  },


  async created() {
    this.getData()
  }
}
</script>

<style scoped>
.clientContact{
  width: 100%;
}
.client-header{
  display: flex;
  justify-content:space-between;
}
.title{
  font-weight: bold;
  font-size:18px
}
.clientContact{
  padding: 30px;
  box-shadow: 0 0px 10px 6px #f5f5f5;
}
.concatPersons{
  margin-top: 10px;
  display: flex;
  overflow: hidden;
}
.concatPerson{
  text-align: center;
  width:calc(100% / 10);
  padding: 0 10px;
  box-sizing: border-box;
  flex-shrink: 0;
  cursor: pointer;
  font-size: 14px;
}
.concatPersonName{
  margin:10px;
}
.concatPersonDept{
  text-overflow:ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: .7rem;
}
</style>